const NotFoundPage = () => {
  return (
    <div>
      NotFoundPage
    </div>
  )
}

export { NotFoundPage }